import React from 'react';

const TruckInventoryIcon = ({ color }) => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_105_358)">
        <path d="M16.5312 17.25H13.6562V20.125H16.5312V17.25Z" fill={color}/>
        <path d="M21.5625 17.25H18.6875V20.125H21.5625V17.25Z" fill={color}/>
        <path d="M16.5312 12.2188H13.6562V15.0938H16.5312V12.2188Z" fill={color}/>
        <path d="M21.5625 12.2188H18.6875V15.0938H21.5625V12.2188Z" fill={color}/>
        <path d="M12.2188 17.25H2.875V7.1875H20.125V10.7812H21.5625V7.1875C21.5621 6.80639 21.4105 6.44101 21.141 6.17152C20.8715 5.90203 20.5061 5.75044 20.125 5.75H15.8125V2.875C15.8121 2.49389 15.6605 2.12851 15.391 1.85902C15.1215 1.58953 14.7561 1.43794 14.375 1.4375H8.625C8.24387 1.43788 7.87846 1.58945 7.60895 1.85895C7.33945 2.12846 7.18788 2.49387 7.1875 2.875V5.75H2.875C2.49387 5.75038 2.12846 5.90195 1.85895 6.17145C1.58945 6.44096 1.43788 6.80637 1.4375 7.1875V17.25C1.43794 17.6311 1.58953 17.9965 1.85902 18.266C2.12851 18.5355 2.49389 18.6871 2.875 18.6875H12.2188V17.25ZM8.625 2.875H14.375V5.75H8.625V2.875Z" fill={color}/>
      </g>
      <defs>
        <clipPath id="clip0_105_358">
          <rect width="23" height="23" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
};

export default TruckInventoryIcon;